<template>
    <el-tabs class="prescription_tabs">
        <el-tab-pane>
            <template #label>
                <span class="prescription_tab_label">
                    <el-icon><Management /></el-icon>
                    <span>自建模版</span>
                </span>
            </template>
            <div class="prescription_header">
                <div class="prescription_header_title">
                    <div>
                        <div class="prescription_header_name">自建处方模版</div>
                        <div class="prescription_header_desc">按剂型快速定位常用处方，点击处方即可查看并导入</div>
                    </div>
                    <el-tag effect="plain" type="info">共 {{ total }} 个模版</el-tag>
                </div>
                <div class="prescription_type_stats">
                    <div v-for="item in billingTypeOptions" :key="item.value"
                         :class="['prescription_stat_card', `prescription_stat_${item.value}`, {active: queryParams.billingType === item.value}]"
                         @click="chooseBillingType(item.value)">
                        <div class="prescription_stat_icon"><el-icon><component :is="item.icon" /></el-icon></div>
                        <div class="prescription_stat_content">
                            <span class="prescription_stat_label">{{ item.label }}</span>
                            <strong>{{ billingTypeStats[item.value] }}</strong>
                        </div>
                    </div>
                </div>
                <div class="prescription_search">
                    <el-input v-model="searchPreName" placeholder="输入模版名称或适应病症" clearable @keyup.enter="searchPrescriptionList">
                        <template #prefix><el-icon><Search /></el-icon></template>
                    </el-input>
                    <el-button type="primary" icon="Search" @click="searchPrescriptionList">搜索</el-button>
                    <el-button v-if="queryParams.billingType" text @click="clearBillingType">查看全部</el-button>
                </div>
            </div>
            <div class="prescription_con" v-loading="prescriptionLoading">
                <el-empty v-if="!prescriptionLoading && prescriptionList.length === 0"
                          description="暂无符合条件的处方模版" :image-size="80" />
                <div :class="['prescription_li', { 'prescription_li_act': choosPreId === item.preId }]"
                     v-for="(item, index) in prescriptionList" :key="item.preId || index" @click="choosePrescription(item)">
                    <div class="prescription_title">
                        <div class="prescription_title_main">
                                <span class="mrr10" v-if="item.isTop ==='0'"><el-tag type="danger">置顶</el-tag></span>
                                <span class="mrr10"><el-tag :type="item.billingType === '0' ? 'primary' : item.billingType === '1' ? 'success' : item.billingType === '2' ? 'warning' : 'danger'"
                                                            disable-transitions>{{ item.billingTypeName.substr(0,1) }}</el-tag></span>
                                <span class="prescription_name">{{item.preName}}</span>
                        </div>
                        <span class="prescription_date">{{item.createTime.substr(0,11)}}</span>
                    </div>
                    <div class="prescription_con_li flex_c_top">
                        <div class="prescription_con_label">适应病症：</div>
                        <div class="prescription_con_info">{{item.instructions === null ? '无': item.instructions}}</div>
                    </div>
                    <div class="prescription_con_li flex_c_top">
                        <div class="prescription_con_med">{{item.medInfo}})</div>
                    </div>
                </div>

            </div>
            <div class="prescription_pagination">
                <el-pagination background layout="prev, pager, next, sizes, total"
                               :current-page="currentPage" :page-size="pageSize" :page-sizes="[10, 20, 30]"
                               :total="total" :disabled="prescriptionLoading"
                               @current-change="handleCurrentChange" @size-change="handleSizeChange" />
            </div>
        </el-tab-pane>
    </el-tabs>



    <!-- 打开双击选择的处方模版-->
    <el-dialog class="choosePrescriptionDialog" v-model="choosePrescriptionDialogVisible" title="导入处方" width="600" center>
<!--        <div class="cho_info">处方模板简介处方模板简介处方模板简介处方模板简介处方模板简介处方模板简介处方模板简介处方模板简介处方模板简介</div>-->
        <div class="cho_title">您将要把【{{chooseSelfTempData.preName}}】导入到当前处方列表中，处方信息见下:</div>
        <div class="cho_line">
            <div class="cho_line_left">适应病症：</div>
            <div class="cho_line_right font_gray">{{chooseSelfTempData.instructions === null ? '无': chooseSelfTempData.instructions}}</div>
        </div>
        <div class="cho_line">
            <div class="cho_line_left">模版剂型：</div>
            <div class="cho_line_right font_gray">{{chooseSelfTempData.billingTypeName === null ? '颗粒': chooseSelfTempData.billingTypeName}}</div>
        </div>
        <div class="cho_line">
            <div class="cho_line_left">药材列表：</div>
            <div class="cho_line_right">{{chooseSelfTempData.medInfo === null ? '无': chooseSelfTempData.medInfo}}</div>
        </div>
        <div class="cho_title_info">请选择【替换】还是【追加】？</div>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="replaceSelfTempChoose(chooseSelfTempData.billingType, chooseSelfTempData.preId)">替换并修改已有药材</el-button>
                <el-button type="primary" @click="addSelfTempChoose(chooseSelfTempData.billingType, chooseSelfTempData.preId)">追加到已有药材</el-button>
            </div>
        </template>
    </el-dialog>

</template>


<script>
import prescription from "@/assets/scripts/components/prescription";
export default prescription;
</script>

<style scoped lang="scss">
@import "@/assets/styles/style.scss";

.prescription_tabs {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.prescription_tabs :deep(.el-tabs__content),
.prescription_tabs :deep(.el-tab-pane) {
    min-height: 0;
    height: 100%;
    overflow: hidden;
}

.prescription_tabs :deep(.el-tab-pane) {
    display: flex;
    flex-direction: column;
}

.prescription_tabs :deep(.el-tabs__header) {
    margin: 0;
    padding: 0 16px;
    background: #fff;
}

.prescription_tabs :deep(.el-tabs__nav-wrap::after) {
    background-color: #f0f2f5;
}

.prescription_tabs :deep(.el-tabs__item) {
    height: 42px;
    color: #909399;
}

.prescription_tabs :deep(.el-tabs__item.is-active) {
    color: #409eff;
}

.prescription_tab_label {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 15px;
    font-weight: 600;
}

.prescription_header {
    padding: 14px 16px 12px;
    background: #fff;
    border-bottom: 1px solid #ebeef5;
}

.prescription_header_title,
.prescription_search {
    display: flex;
    align-items: center;
    gap: 10px;
}

.prescription_search {
    width: 100%;
    margin: 0;
    padding: 0;
    background: transparent;
    border-radius: 0;
}

.prescription_header_title {
    justify-content: space-between;
    margin-bottom: 14px;
}

.prescription_header_name {
    color: #303133;
    font-size: 16px;
    font-weight: 600;
}

.prescription_header_desc {
    margin-top: 4px;
    color: #909399;
    font-size: 12px;
}

.prescription_type_stats {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 8px;
    margin-bottom: 14px;
}

.prescription_stat_card {
    display: flex;
    align-items: center;
    min-width: 0;
    padding: 9px 8px;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    transition: all .2s ease;
}

.prescription_stat_card:hover,
.prescription_stat_card.active {
    transform: translateY(-1px);
    box-shadow: 0 3px 10px rgba(64, 158, 255, .15);
}

.prescription_stat_card.active {
    color: #fff;
}

.prescription_stat_icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 28px;
    width: 28px;
    height: 28px;
    margin-right: 6px;
    border-radius: 5px;
    font-size: 16px;
}

.prescription_stat_content {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.prescription_stat_label {
    overflow: hidden;
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.prescription_stat_content strong {
    margin-top: 2px;
    font-size: 17px;
    line-height: 20px;
}

.prescription_stat_0 { color: #409eff; background: #f0f8ff; border-color: #b3d8ff; }
.prescription_stat_1 { color: #67c23a; background: #f0f9eb; border-color: #c2e7b0; }
.prescription_stat_2 { color: #e6a23c; background: #fdf6ec; border-color: #f5dab1; }
.prescription_stat_3 { color: #8e7cc3; background: #f6f3fc; border-color: #d8ccef; }
.prescription_stat_0 .prescription_stat_icon { background: #d9ecff; }
.prescription_stat_1 .prescription_stat_icon { background: #e1f3d8; }
.prescription_stat_2 .prescription_stat_icon { background: #faecd8; }
.prescription_stat_3 .prescription_stat_icon { background: #e9e2f7; }
.prescription_stat_card.active .prescription_stat_icon { color: inherit; background: rgba(255, 255, 255, .22); }
.prescription_stat_0.active { background: #409eff; border-color: #409eff; }
.prescription_stat_1.active { background: #67c23a; border-color: #67c23a; }
.prescription_stat_2.active { background: #e6a23c; border-color: #e6a23c; }
.prescription_stat_3.active { background: #8e7cc3; border-color: #8e7cc3; }

.prescription_search .el-input { flex: 1; }
.prescription_con {
    padding: 12px 4px 4px;
    overflow-x: hidden;
    overflow-y: auto;
    background: #f5f7fa;
}

.prescription_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.prescription_title_main {
    display: flex;
    align-items: center;
    min-width: 0;
    overflow: hidden;
}

.prescription_name {
    overflow: hidden;
    color: #303133;
    font-size: 15px;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.prescription_date {
    flex: 0 0 auto;
    color: #a8abb2;
    font-size: 12px;
}

.prescription_li {
    transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease;
}

.prescription_li:hover,
.prescription_li_act {
    transform: translateY(-1px);
    box-shadow: 0 5px 14px rgba(64, 158, 255, .12);
}

.prescription_li_act {
    position: relative;
    background: linear-gradient(135deg, #f0f8ff 0%, #ecf5ff 100%);
    border-color: #409eff;
    box-shadow: 0 5px 16px rgba(64, 158, 255, .2);
}

.prescription_li_act::before {
    position: absolute;
    top: 12px;
    bottom: 12px;
    left: -1px;
    width: 3px;
    border-radius: 0 3px 3px 0;
    background: #409eff;
    content: '';
}

.prescription_li_act .prescription_name {
    color: #1d6fb8;
}

.prescription_pagination {
    display: flex;
    flex: 0 0 auto;
    justify-content: center;
    padding: 16px 0 2px;
}

@media (max-width: 520px) {
    .prescription_type_stats { gap: 5px; }
    .prescription_stat_card { padding: 7px 4px; }
    .prescription_stat_icon { margin-right: 3px; }
    .prescription_search .el-button { padding: 8px; }
}
</style>